module.exports = __webpack_public_path__ + "7d088296/img/share-action-icon.9c12578c.svg";